/**
 * @generated SignedSource<<02b1f5205ce77cac505dc9c520f61477>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type OrganizationReportType = "globalInsights" | "messages" | "userEngagement" | "workspaceInsights" | "%future added value";
export type AdminReportsDashboardQuery$variables = {
  id: string;
  reportType: OrganizationReportType;
};
export type AdminReportsDashboardQuery$data = {
  readonly organization: {
    readonly reportsUrl?: string | null;
  } | null;
};
export type AdminReportsDashboardQuery = {
  response: AdminReportsDashboardQuery$data;
  variables: AdminReportsDashboardQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "reportType"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "reportType",
          "variableName": "reportType"
        }
      ],
      "kind": "ScalarField",
      "name": "reportsUrl",
      "storageKey": null
    }
  ],
  "type": "Organization",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AdminReportsDashboardQuery",
    "selections": [
      {
        "alias": "organization",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AdminReportsDashboardQuery",
    "selections": [
      {
        "alias": "organization",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "84231ca521eeafbf21e68e2f5a373dc0",
    "id": null,
    "metadata": {},
    "name": "AdminReportsDashboardQuery",
    "operationKind": "query",
    "text": "query AdminReportsDashboardQuery(\n  $id: ID!\n  $reportType: OrganizationReportType!\n) {\n  organization: node(id: $id) {\n    __typename\n    ... on Organization {\n      reportsUrl(reportType: $reportType)\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "92c37eb2d875f912491bbf2d738d6c34";

export default node;
